module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-dla-klasy-2-mj-3.64d53afa.png";